import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center text-sm font-medium mt-14" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.review')
};
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import ActionItems from '@/components/action_items/ActionItems.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ReviewPhase',
    setup(__props) {
        const retroStore = useRetroStore();
        const { actionItems } = storeToRefs(retroStore);
        return (_ctx, _cache) => {
            const _component_SectionHeading = _resolveComponent("SectionHeading");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_SectionHeading, {
                    heading: _ctx.$t('title'),
                    subheading: _ctx.$t('subtitle')
                }, null, 8, ["heading", "subheading"]),
                _createVNode(ActionItems, {
                    class: "p-10",
                    items: _unref(actionItems)
                }, null, 8, ["items"])
            ]));
        };
    }
});
